import FormControl from "@mui/material/FormControl";
import Select, { type SelectProps } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Text from "@commons/Typography/Text";
import { FormHelperText, IconButton } from "@mui/material";
import Close from "@mui/icons-material/Close";
import { isEmpty } from "@utils/formatters";

type Option = { value: string | number; label: string };

type SelectInputProps = SelectProps & {
  label?: string;
  options: Option[];
  helperText?: string;
};

function SelectInput({
  label,
  options,
  helperText,
  ...props
}: SelectInputProps) {
  const ClearIcon = ({ onClick }: { onClick: () => void }) => (
    <IconButton
      size="small"
      className="mr-2"
      onClick={onClick}
      aria-label="Limpar seleção"
    >
      <Close className="w-5 h-5" />
    </IconButton>
  );

  const showClearIcon = !isEmpty(props.value);

  const handleClear = () => {
    props.onChange?.(
      {
        target: { value: "" },
      } as React.ChangeEvent<HTMLInputElement>,
      undefined,
    );
  };

  return (
    <FormControl fullWidth={props.fullWidth} className="min-w-28">
      {label && (
        <label data-testid="select-label" className="mb-2 font-medium">
          <Text>{label}</Text>
        </label>
      )}
      <div className="relative">
        <Select
          {...props}
          inputProps={{ "data-testid": "select-input" }}
          IconComponent={
            showClearIcon
              ? (props) => <ClearIcon onClick={handleClear} {...props} />
              : undefined
          }
        >
          {options.map((option) => (
            <MenuItem
              key={option.value}
              value={option.value}
              className="max-w-full"
            >
              <div className="truncate w-full" title={option.label}>
                <Text size="sm">{option.label}</Text>
              </div>
            </MenuItem>
          ))}
        </Select>
      </div>
      {helperText && (
        <FormHelperText error={props.error}>{helperText}</FormHelperText>
      )}
    </FormControl>
  );
}

export default SelectInput;
